export const LOCAL_BOOKING_TIME_EXPIRED_CODE = "LOCAL_BOOKING_TIME_EXPIRED" as const;

export type LocalLessonCalendarAdapterState =
  | Readonly<{ status: "available"; calendarLink: string }>
  | Readonly<{ status: "empty"; message: string }>
  | Readonly<{ status: "error"; message: string }>
  | Readonly<{ status: "expired"; message: string }>;

type CalendarResponsePayload = Readonly<{
  calendarLink?: unknown;
  calendarState?: unknown;
  code?: unknown;
}> | null;

export function adaptLocalLessonCalendarResponse(
  responseOk: boolean,
  payload: CalendarResponsePayload,
): LocalLessonCalendarAdapterState {
  if (payload?.code === LOCAL_BOOKING_TIME_EXPIRED_CODE) {
    return {
      status: "expired",
      message: "That provisional time is no longer available. Please choose another live time.",
    };
  }

  if (responseOk && payload?.calendarState === "empty") {
    return {
      status: "empty",
      message: "No live times are available right now. You can share a preferred time instead; it remains a request until separately confirmed.",
    };
  }

  const calendarLink = typeof payload?.calendarLink === "string"
    ? payload.calendarLink.trim()
    : "";
  if (responseOk && calendarLink) {
    return { status: "available", calendarLink };
  }

  return {
    status: "error",
    message: "Live availability could not be loaded. You can share a preferred time instead; it remains a request until separately confirmed.",
  };
}

export function isLocalBookingTimeExpiredCode(value: unknown) {
  return value === LOCAL_BOOKING_TIME_EXPIRED_CODE;
}
